import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const GrnMasterList = lazy(() => import('../../pages/grn/grn_master/GrnMasterList'));
const AddGrnMaster = lazy(() => import('../../pages/grn/grn_master/AddGrnMaster'));
const UpdateGrnMaster = lazy(() => import('../../pages/grn/grn_master/UpdateGrnMaster'));

export const GrnImport = {
    RoutesMap,
    GrnMasterList,
    AddGrnMaster,
    UpdateGrnMaster,
}
